import { useEffect, useState, useCallback } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";

import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { Manifesto } from "@/components/Manifesto";
import { Collection } from "@/components/Collection";
import { CandleEdit } from "@/components/CandleEdit";
import { Showpieces } from "@/components/Showpieces";
import { ShopTheLook } from "@/components/ShopTheLook";
import { Signature } from "@/components/Signature";
import { Hampers } from "@/components/Hampers";
import { Essence } from "@/components/Essence";
import { HamperBuilder } from "@/components/HamperBuilder";
import { Enquiry } from "@/components/Enquiry";
import { Footer } from "@/components/Footer";

function App() {
  const [prefill, setPrefill] = useState(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  const scrollTo = useCallback((id) => {
    if (id === "top") return window.scrollTo({ top: 0, behavior: "smooth" });
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  }, []);

  const onBuild = useCallback((data) => setPrefill({ ...data, ts: Date.now() }), []);

  const onGift = useCallback((tier) => {
    setPrefill({
      kind: "hamper",
      occasion: `Diwali — ${tier.name} (${tier.level})`,
      items: tier.items,
      ts: Date.now(),
    });
  }, []);

  return (
    <div className="App bg-[#F7F5F0]">
      <Toaster position="top-center" richColors />
      <Header scrollTo={scrollTo} />
      <main>
        <Hero scrollTo={scrollTo} />
        <EditorialMarquee dark words={["A Story", "Elegance", "Home", "Exclusivity", "Creativity"]} />
        <Manifesto />
        <Collection scrollTo={scrollTo} />
        <Signature scrollTo={scrollTo} />
        <CandleEdit scrollTo={scrollTo} />
        <Showpieces scrollTo={scrollTo} />
        <ShopTheLook onBundle={onBuild} />
        <EditorialMarquee words={["Cushions", "Candles", "Vases", "Hampers", "Corporate Gifting"]} />
        <Hampers scrollTo={scrollTo} />
        <Essence onGift={onGift} />
        <HamperBuilder onContinue={onBuild} />
        <Enquiry prefill={prefill} />
      </main>
      <Footer scrollTo={scrollTo} />
    </div>
  );
}

export default App;
